import { AuditModel } from "./auditModel";

export class AuditClass  {
    item_id: number;
    item_text: string;
    sequence: number;
    short: string;
}

export const monthlistFrequencies: AuditClass [] = [
    { item_id: 1, item_text: 'January', sequence: 7, short:'Jan'},
    { item_id: 2, item_text: 'February', sequence: 8, short: 'Feb' },
    { item_id: 3, item_text: 'March', sequence: 9, short: 'Mar' },
    { item_id: 4, item_text: 'April', sequence: 10, short: 'Apr' },
    { item_id: 5, item_text: 'May', sequence: 11, short: 'May' },
    { item_id: 6, item_text: 'June', sequence: 12, short: 'Jun' },
    { item_id: 7, item_text: 'July', sequence: 1, short: 'Jul' },
    { item_id: 8, item_text: 'August', sequence: 2, short: 'Aug' },
    { item_id: 9, item_text: 'September', sequence: 3, short: 'Sep' },
    { item_id: 10, item_text: 'October', sequence: 4, short: 'Oct' },
    { item_id: 11, item_text: 'November', sequence: 5, short: 'Nov' },
    { item_id: 12, item_text: 'December', sequence: 6, short: 'Dec' }
];

export const ordinalNumber: AuditClass[] = [
    { item_id: 1, item_text: 'First', sequence: 1, short: '1st' },
    { item_id: 2, item_text: 'Second', sequence: 2, short: '2nd' },
    { item_id: 3, item_text: 'Third', sequence: 3, short: '1st' },
];
export const endType: AuditClass[] = [
    { item_id: 1, item_text: 'On', sequence: 1, short: 'On' },
    { item_id: 2, item_text: 'After', sequence: 2, short: 'After' }
];
export const frequency: AuditClass[] = [
    { item_id: 1, item_text: 'Monthly', sequence: 1, short: 'Monthly' },
    { item_id: 2, item_text: 'Quaterly', sequence: 2, short: 'Quaterly' },
    { item_id: 3, item_text: 'Yearly', sequence: 3, short: 'Yearly' }
];

export class QuarterListFrequencies {
    item_id: number;
    item_text: string;
}

export const quarterlistFrequencies: QuarterListFrequencies[] = [
    { item_id: 1, item_text: 'Q1-Sep' },
    { item_id: 2, item_text: 'Q2-Dec'},
    { item_id: 3, item_text: 'Q3-Mar'},
    { item_id: 4, item_text: 'Q4-Jun'}
];

export class DropDownModel {
    item_id: number;
    item_text: string;
}

export const invoiceDueDaysList: DropDownModel[] = [
  { item_id: 1, item_text: '7' },
  { item_id: 2, item_text: '14' },
  { item_id: 3, item_text: '21' },
  { item_id: 4, item_text: '28' },
  { item_id: 5, item_text: '60' },
  { item_id: 6, item_text: '90' }
];

export class TimesheetUnitListModel {
    item_id: number;
    unitListVal: number;
}
export const timesheetUnitValueList: TimesheetUnitListModel[] = [
    { item_id: 1, unitListVal: 6 },
    { item_id: 2, unitListVal: 10 },
    { item_id: 3, unitListVal: 15 }
];

export class FirmDetailModel extends AuditModel {
  public accountingFirmId: number;
  public firmDetailId: number;
  public firmName: string;
  public entityName: string;
  public abn: string;
  public acn: string;
  public description: string;
  public addr1: any;
  public addr2: string;
  public suburb: string;
  public postalCode: any;
  public countryId: number;
  public stateId: number;
  public imageURL: string = "";
  public firmLogo: string = "";
  public invoiceDueDate: string = "";
  public gstSubTotal: string = "";
}

export interface UpdateFirmOfficePayload {
  firmDetailId: number;
  canEnableOffice: boolean;
}
